export enum TagStatus {
  fault = 'fault',
  running = 'running',
  starting = 'starting',
  stopped = 'stopped',
}

export interface EquipmentStatusTagProps {
  className?: string;
  status: TagStatus;
  testId?: string;
  text: string;
}
